import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { Field } from 'redux-form';
import ValidatedFormInput from 'components/ValidatedFormInput';
import { renderDropdown } from './FormFieldRenderers';
import PriceBreakdown from './PriceBreakdown';

const BasicInfoSection = ({
  subscriptionProductOptions,
  subscriptionProductValue,
  quantityValue,
  discountPercentageValue,
  basePackages,
}) => {
  const selectedBasePackage = basePackages.find(
    pkg => pkg.id === subscriptionProductValue
  );
  const basePrice = selectedBasePackage
    ? selectedBasePackage.price_per_month
    : 0;
  const quantity = parseInt(quantityValue, 10) || 0;
  const discountPercentage = parseFloat(discountPercentageValue) || 0;
  const shouldShowCalculator = subscriptionProductValue && quantity > 0;

  return (
    <div style={{ marginBottom: '1.5em' }}>
      <h4>Basic Information</h4>
      <Form.Group widths="equal">
        <Form.Field>
          <label>Package Name</label>
          <Field
            name="name"
            component={ValidatedFormInput}
            placeholder="Enter package name"
          />
        </Form.Field>
        <Field
          name="subscription_product_id"
          component={renderDropdown}
          options={subscriptionProductOptions}
          label="Base Module"
          placeholder="Select base module"
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Field>
          <label>Duration (months)</label>
          <Field
            name="quantity"
            component={ValidatedFormInput}
            placeholder="1"
            type="number"
          />
        </Form.Field>
        <Form.Field>
          <label>Discount (%)</label>
          <Field
            name="discount_percentage"
            component={ValidatedFormInput}
            placeholder="0"
            type="number"
          />
        </Form.Field>
      </Form.Group>
      {shouldShowCalculator && (
        <PriceBreakdown
          basePrice={basePrice}
          duration={quantity}
          discount={discountPercentage}
        />
      )}
    </div>
  );
};

BasicInfoSection.propTypes = {
  subscriptionProductOptions: PropTypes.array.isRequired,
  subscriptionProductValue: PropTypes.number,
  quantityValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  discountPercentageValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  basePackages: PropTypes.array.isRequired,
};

BasicInfoSection.defaultProps = {
  subscriptionProductValue: null,
  quantityValue: 1,
  discountPercentageValue: 0,
};

export default BasicInfoSection;
